
import { ChangeDetectionStrategy, Component, signal, Input } from '@angular/core';
import { SvgIconComponent } from '@modules/shared/components/svg-icon/svg-icon.component';
import { StateOfChargeMeasurementPoint } from '@modules/shared/models';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-battery-status-info',
    templateUrl: './battery-status-info.component.html',
    styleUrls: ['./battery-status-info.component.scss'],
    imports: [TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class BatteryStatusInfoComponent {
    @Input() set batteryStatusInfo(value: StateOfChargeMeasurementPoint) {
        this.stateOfCharge.set(value);
        this.updateDerivedValues();
    }

    protected stateOfCharge = signal<StateOfChargeMeasurementPoint>(undefined);
    protected iconName = signal<string>(undefined);
    protected diffMinutes = signal<number>(undefined);

    protected path = 'assets/icons/battery-question-mark.svg';

    private updateDerivedValues(): void {
        const soc = this.stateOfCharge();
        if (!soc || !soc.measuredAt) {
            this.diffMinutes.set(undefined);
            this.iconName.set(undefined);
            return;
        }

        const measuredDate = new Date(soc.measuredAt);
        const now = new Date();
        const diff = (now.getTime() - measuredDate.getTime()) / 1000 / 60;

        this.diffMinutes.set(diff);
        this.iconName.set(this.setIconName(soc, diff));
    }

    private setIconName(soc: StateOfChargeMeasurementPoint, diffMinutes: number): string {
        if (!soc) return undefined;

        const sensorValue = soc.sensorValue;
        let iconName = '';
    
        if(sensorValue >= 100) {
            iconName = 'fa-battery-full';
        } else if(sensorValue < 100 && sensorValue >= 75) {
            iconName = 'fa-battery-three-quarters';
        } else if(sensorValue < 75 && sensorValue >= 50) {
            iconName = 'fa-battery-half';
        } else if(sensorValue < 50 && sensorValue >= 10) {
            iconName = 'fa-battery-quarter';
        } else if(sensorValue < 10 && sensorValue >= 1) {
            iconName = 'fa-battery-empty';
        } else {
            iconName = 'fa-battery-empty';
        }

        if (diffMinutes >= 10) {
            iconName += ' gray-icon';
        }

        return iconName;
    }
}